import XLSX from "xlsx";

/**
 * ULファイルの中に指定の更新差分を含んでいるかcheck
 * @param アップロードファイル
 * @param 開始行
 * @param 指定列
 * @param シート名
 * @param 更新差分
 * @return bool
 */
export const ulFileCheck = async (
  uploadFile: File | undefined,
  row_number: number,
  col_number: number,
  sheet_name: string,
  update_differencial: string
) => {
  let columC: string[] = [];
  try {
    if (uploadFile !== undefined) {
      // ファイルを読み込んみ、解約が含まれている場合はtrueを返却
      await uploadFile.arrayBuffer().then((buffer) => {
        // ファイルを読み込む
        const workbook = XLSX.read(buffer, { type: "buffer", bookVBA: true });
        // シート名「提出用」から、ワークシートを取得する
        const worksheet = workbook.Sheets[sheet_name];
        //加盟店申請区分に値が入っている行までデータを取得する
        const range = XLSX.utils.decode_range(worksheet["!ref"] || "");
        for (row_number; row_number <= range.e.r; row_number++) {
          const cellAddress = XLSX.utils.encode_cell({
            c: col_number,
            r: row_number,
          });
          const cell = worksheet[cellAddress];
          if (cell && cell.v) {
            columC.push(cell.v);
          } else {
            break;
          }
        }
      });
    }
  } catch {
    //ULファイル間違いなど、エラー発生時
    return false;
  }
  return columC.includes(update_differencial);
};
